import { Box, Skeleton, SkeletonText } from '@chakra-ui/react';
import { Size } from '../../../core/types/ui/size';
import { SheetDefaults } from '../../constants/sheetDefaults';
import useSheetTheme from '../../hooks/useSheetTheme';
import { WindowSizes } from '../../../windows/constants/windowSizes';

const { defaultColWidth, defaultRowHeight } = SheetDefaults;

interface LoaderProps extends Size {}
const Loader: React.FC<LoaderProps> = ({ width, height }) => {
  const { stroke, secondaryFill } = useSheetTheme();
  const cell = (
    left: number,
    top: number,
    width: number,
    height: number,
    key: string
  ) => (
    <Box
      key={key}
      width={`${width}px`}
      height={`${height}px`}
      position="absolute"
      top={`${top}px`}
      left={`${left}px`}
      padding="2px"
      border={`1px solid ${stroke}`}
      opacity={0.7}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Skeleton
        width={`90%`}
        height={`14px`}
        borderRadius={5}
        fadeDuration={0.9}
        speed={1}
        startColor={stroke}
        endColor={secondaryFill}
      />
    </Box>
  );

  const cells = () => {
    const Cells: JSX.Element[] = [];
    const header = 45;
    const rows = Math.floor(height / defaultRowHeight);
    const cols = Math.floor(width / defaultColWidth);

    // console.log('cols', cols);
    // console.log('rows', rows);

    let top = WindowSizes.controlBarHeight;
    for (let r = 0; r <= rows; r++) {
      Cells.push(cell(0, top, header, defaultRowHeight, `row-${r}`));

      top += defaultRowHeight;
    }

    // Cells.push(cell(0, 0, defaultColWidth, defaultRowHeight, 0, 0));

    let x = header;
    for (let c = 0; c <= cols; c++) {
      let y = WindowSizes.controlBarHeight;
      for (let r = 0; r <= rows; r++) {
        Cells.push(cell(x, y, defaultColWidth, defaultRowHeight, `${c}-${r}`));
        y += defaultRowHeight;
      }

      x += defaultColWidth;
    }
    return Cells;
  };

  return <>{cells()}</>;
};

export default Loader;
